<template>
  <div style="cursor: pointer; overflow-y: hidden; height: 100%; display: flex; flex-direction: column;">
    <div 
      style="overflow-y: scroll; " 
      :style="{ height: (localAddress && localAddress.center) ? (addresses.length === 0 ? 'auto' : '40%') : '100%' }"
      class="custom-scroll">
      <div class="row m-0 ">
        <div class="col">
          <span 
            v-if="title" 
            style="color:#011638; font-weight: 600; font-size: 1.2rem;">{{title}}</span>
          <span 
            v-else 
            style="color:#011638; font-weight: 600; font-size: 1.2rem;">Ubicación</span>
        </div>
      </div>
      <div class="search-btn mt-2">
        <i class="fa-solid fa-search " />
        <input
          ref="addressInput"
          v-model="localSearch"
          autocomplete="off"
          class="search-input ms-3"
          :placeholder="text ? text : '¿Dónde buscas garaje?'"
          @input="handleInput"
        >
        <i
          v-if="localSearch.length >0"
          class="fa-solid fa-trash"
          @click="localSearch='';addresses= []"
        />
      </div>
      <div class="mt-4">
        <div
          v-if="localSearch.length == 0"
          class="d-flex mb-2"
          style="color:#15E0DD"
        >
          <div class="d-flex align-items-center justify-content-center me-2">
            <i class="fa-solid fa-location fs-5 mb-2" />
          </div>
          <div
            class="flex-grow-1"
            @click="selectCurrentLocation()"
          >
            <p class="mb-2">
              Posición actual
            </p>
            <span 
              v-if="location_error"
              class="text-danger">
              No podemos acceder a tu ubicación. Habilita los permisos en tu navegador.
            </span>
            <!--<span style="color: #8E97A7">Cerca de {{ currentLocation.address || "..." }}</span>-->
            <hr
              class="mb-0 mt-1"
              style="color: #8E97A7"
            >
          </div>
        </div>
        <!-- V-FOR -->
        <div
          v-for="address in addresses"
          :key="address.id"
          class="row m-0 mb-2"
          style="color: #8E97A7"
          @click="selectAddress(address)"
        >
          <div class="col-1 d-flex align-items-center justify-content-center">
            <i class="fa-solid fa-location-dot fs-3 mb-2" />
          </div>
          <div class="col-11">
            <p
              class="mb-0"
              style="color: #011638"
            >
              {{ address.street }}
            </p>
            <span>{{ address.city }}</span>
            <hr class="mb-0 mt-1">
          </div>
        </div>
        <p
          v-if="text2 && localSearch.length == 0"
          style="color:#011638;"
          class="mt-4 text-center"
        >
          {{ text2 }}
        </p>
      </div>
    </div>
    <div 
      v-if="localAddress && localAddress.center"
      style="flex-grow: 1; overflow: hidden; width: 100%;position: relative;">
      <div
        id="map"
        class="w-100"
        style="height:calc(100% + 15px)"
      >
      </div>
      <div
        style="
          position: absolute;
          top: 10px;
          left: 50%;
          transform: translateX(-50%);
          background-color: rgba(0, 0, 0, 0.6);
          color: white;
          padding: 8px 12px;
          border-radius: 8px;
          font-size: 12px;
          z-index: 1000;
          width: 80%;
        "
      >
        Puedes mover el icono para seleccionar la ubicación exacta
      </div>
    </div>
    <div 
      class="d-flex align-items-center justify-content-center"
      style="position: fixed; bottom: 3%; width: 100%; left: 0;z-index: 1000 !important;">
      <button 
        v-if="localAddress && localAddress.center"
        style="background-color: #011638; font-size: 1.1rem;font-weight: 500; color: white"
        class="btn px-5"
        @click="this.$emit('get-data-address', localAddress);"
      >
        Confirmar ubicación
        <i
          class="fa-solid fa-angle-right ms-1"
          style="font-size: 1rem;"
        />
      </button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import L from 'leaflet';
  import 'leaflet.markercluster';
  import parkerIcon from '@/assets/parker_icon.png'
  import driverIcon from '@/assets/driver_icon.png'

  export default {
    name: 'AddressBrowserComponent',
    props: {
        address: {
            type: Object,
            required: false
        },
        text:{
            type: String,
            required:false
        },
        text2:{
            type: String,
            required:false
        },
        title:{
            type: String,
            required:false
        },
        is_parker:{
            type: Boolean,
            required: false,
        },
    },
    data: function() {
        return {
            typingTimer: null,
            centro: [38.345997, -0.490686],
            addresses: [],
            currentLocation: {
              address: ""
            },
            localSearch: this.address?.street || this.address?.city || "",
            location_error: false,
            map: null,
            markers: L.markerClusterGroup(),
            circles: null,
            localAddress: null
        }
    },
    watch:{
      address: {
        immediate: true, // Se ejecuta al inicio
        handler(newVal) {
          this.localAddress = structuredClone(newVal);
        }
      },
      'addresses.length': {
        handler() {
          this.$nextTick(() => {
            if (this.map) {
              this.map.invalidateSize();
            }
          });
        }
      }
    },
    mounted(){
      if(this.address.street){
        this.selectAddress(this.address)
      }
    },
    methods: {
      update_map(){
        if(this.localAddress && this.localAddress.center){

          if (this.map) {
            this.map.remove(); // elimina el mapa del DOM y limpia referencias internas
          }
          this.map = L.map('map', {
            zoomControl: false,
            zoom: 1,
            zoomAnimation: true,
            fadeAnimation: true,
            markerZoomAnimation: true,
            scrollWheelZoom: true,
            dragging: true
          });

          this.map.invalidateSize()
          this.map.setView(this.localAddress.center, 15)
          L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
              maxZoom: 20,
              minZoom: 1
          }).addTo(this.map);

          this.markers.clearLayers();

          const iconUrl = this.is_parker ? parkerIcon : driverIcon
          const width_icon = this.is_parker ? 40 : 50

          const customIcon = L.icon({
            iconUrl, // Ruta a la imagen
            iconSize: [width_icon, 50], // Tamaño del ícono
            iconAnchor: [20, 30], // Punto de anclaje (base del ícono)
            popupAnchor: [0, -40], // Punto del popup relativo al ícono
          });

          const marker = L.marker(this.localAddress.center, {
            icon: customIcon,
            draggable: true
          });

          marker.on('dragend', async (event) => {
            const newLatLng = event.target.getLatLng();
            this.localAddress.center = [newLatLng.lat, newLatLng.lng];

            try {
              this.localAddress = await this.searchAddressByCoordinates(newLatLng.lat, newLatLng.lng);
              this.localSearch = this.localAddress.street
            } catch (error) {
              console.log("Error buscando dirección: " + error);
            }

            // Opcional: actualizar el círculo de radio con la nueva posición
            this.circles.forEach(circle => this.map.removeLayer(circle));
            const newCircle = L.circle([newLatLng.lat, newLatLng.lng], {
              radius: 500,
              color: '#011638',
              fillColor: '#15E0DD',
              opacity: 0,
              fillOpacity: 0.2
            }).addTo(this.map);
            this.circles = [newCircle];

            this.$emit('clicked-icon');
          });

          this.markers.addLayer(marker);
          this.map.addLayer(this.markers);

          this.circles = this.circles || [];

          // Elimina los círculos antiguos
          this.circles.forEach(circle => {
            this.map.removeLayer(circle);
          });
          this.circles = [];

          const circle = L.circle(this.localAddress.center, {
            radius: 500,         // En metros
            color: '#011638',
            fillColor: '#15E0DD',
            opacity: 0,
            fillOpacity: 0.2
          }).addTo(this.map);

          this.circles.push(circle);

        }
      },
        async selectCurrentLocation() {
          try {
            const location = await this.getCurrentLocation(); // Ahora espera el resultado
            this.selectAddress(location);
            this.location_error = false
          } catch (error) {
            this.location_error = true
            console.error("Error obteniendo la ubicación:", error);
          }
        },
        getCurrentLocation() {
          return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                async (position) => {
                  const { latitude, longitude } = position.coords;

                  try {
                    const address = await this.searchAddressByCoordinates(latitude, longitude);
                    resolve(address); // Devuelve la dirección
                  } catch (error) {
                    reject("Error buscando dirección: " + error);
                  }
                },
                (error) => {
                  reject("Error al obtener la ubicación: " + error.message);
                }
              );
            } else {
              reject("La geolocalización no está soportada por este navegador.");
            }
          });
        },
        async selectAddress(address) {
          this.localAddress=address
          this.localSearch = this.localAddress.street
          await this.$nextTick();
          await this.update_map()
          //await this.searchAddress(this.localSearch)
          this.addresses = []
          this.$emit('address-selected');
        },
        async searchAddressByCoordinates(lat, lon) {
          try {
            const apiKey = "AIzaSyAJJdwleSM-HKXt3f7a_4UbXGDhTy6X_vY"; // Pon tu API Key de Google Maps
            const response = await axios.get(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&key=${apiKey}&language=es`
            );

            if (response.data.results.length > 0) {
              const result = response.data.results[0];
              const formatted = this.formatGoogleResult(result);

              const locationDetails = await this.fetchDetailsFromMapbox(lat, lon);

              const location = {
                id: result.place_id, // Google usa place_id
                address: formatted.address,
                city: locationDetails.city,
                street: formatted.street,
                zip_code: locationDetails.postal_code,
                state: locationDetails.country,
                center: [lat, lon], // Coordenadas, ya las tienes
                context: result.address_components || [] // Información adicional
              };

              this.currentLocation = location;
              return location;
            }
            throw new Error("No se encontró una dirección");
          } catch (error) {
            console.error("Error al buscar dirección por coordenadas", error);
            throw error;
          }
        },
        formatGoogleResult(result) {
          const components = result.address_components;
          
          const getComponent = (types) => {
            const comp = components.find(c => types.every(type => c.types.includes(type)));
            return comp ? comp.long_name : '';
          };

          return {
            address: result.formatted_address,
            city: getComponent(['locality']) || getComponent(['administrative_area_level_2']),
            street: getComponent(['route']),
            zip_code: getComponent(['postal_code']),
            state: getComponent(['administrative_area_level_1'])
          };
        },
        /* global google */
        async searchAddress(value) {
          if (!value) {
            this.addresses = [];
            return;
          }

          const service = new google.maps.places.PlacesService(document.createElement('div'));

          service.textSearch({ query: value }, async (results, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              const promises = results.slice(0, 5).map(result => {
                return new Promise((resolve, reject) => {
                  console.log(reject)
                  service.getDetails({ placeId: result.place_id, fields: ['geometry', 'formatted_address'] }, async (details, statusDetail) => {
                    if (statusDetail === google.maps.places.PlacesServiceStatus.OK) {
                      const lat = details.geometry.location.lat();
                      const lng = details.geometry.location.lng();

                      // Obtenemos ciudad, provincia y código postal desde Mapbox
                      const locationDetails = await this.fetchDetailsFromMapbox(lat, lng);

                      resolve({
                        street: details.formatted_address || result.formatted_address,
                        city: locationDetails.city,
                        state: locationDetails.country,
                        zip_code: locationDetails.postal_code,
                        center: [lat, lng],
                      });
                    } else {
                      console.error('Google Places getDetails error:', statusDetail);
                      resolve(null);
                    }
                  });
                });
              });

              const detailedAddresses = (await Promise.all(promises)).filter(addr => addr !== null);
              this.addresses = detailedAddresses;
            } else {
              console.error('Google Places error:', status);
            }
          });
        },
        // Función para sacar la ciudad
        extractCity(components) {
          const city = components.find(c => c.types.includes('locality')) ||
                      components.find(c => c.types.includes('administrative_area_level_2')) ||
                      components.find(c => c.types.includes('administrative_area_level_1'));
          return city ? city.long_name : '';
        },
        extractState(components) {
          const city = components.find(c => c.types.includes('locality')) ||
                      components.find(c => c.types.includes('administrative_area_level_2')) ||
                      components.find(c => c.types.includes('administrative_area_level_1'));
          return city ? city.long_name : '';
        },
        async fetchDetailsFromMapbox(lat, lng) {
          try {
            const token = 'pk.eyJ1IjoiamJuMjAwMSIsImEiOiJjbGt3cW95NjMwM2JsM2tueWVrMHV0MnJoIn0.nI9ULLd2W_4P0JCku50Iww'; // Tu token de Mapbox
            const response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${token}`);
            const data = await response.json();

            let postal_code = '';
            let city = '';
            let country = '';

            if (data && data.features && data.features.length > 0) {
              for (const feature of data.features) {
                if (feature.place_type.includes('postcode')) {
                  postal_code = feature.text;
                }
                if (feature.place_type.includes('place')) {
                  city = feature.text;
                }
                if (feature.place_type.includes('country')) {
                  country = feature.text;
                }
              }
            }

            return { postal_code, city, country };
          } catch (error) {
            console.error('Error fetching details from Mapbox:', error);
            return { postal_code: '', city: '', country: '' };
          }
        },
        handleInput() {
            clearTimeout(this.typingTimer);

            // Iniciar un temporizador para verificar si el usuario ha dejado de escribir durante 1 segundo
            this.typingTimer = setTimeout(() => {
                this.onTypingStopped();
            }, 1000);
            // this.PasarVariables()
        },
        onTypingStopped() {
            this.searchAddress(this.$refs.addressInput.value)
        },
    }
  }
</script>

<style>
    .search-btn{
    display: flex;
    height: 55px;
    background: #fff;
    padding: 20px;
    font-size: 18px;
    align-items: center;
    cursor: pointer;
    border: 2px solid #dbdbdb;
    border-radius: 12px;
    color: #8E97A7;
  }

  .search-input{
    box-shadow: 0px;
    width: 90%;
    border: 0px;
  }

  .search-input:focus{
    border: 0px !important;
    outline: none;
  }
</style>
